import { CheckForLecturerConflictArgs, checkForTimelineItemTimeConflict } from '@modules/timetable';
import getConfirmChangeFunction from '@modules/timetable/functions/timeline/getConfirmChangeFunction';

const confirmChange = getConfirmChangeFunction({
  title: 'Lecturer conflict',
  contentStartText: 'lecturer assigned for this item is also assigned for',
});

export const checkForLecturerConflict = ({
  timelineItems,
  item,
  startTime,
  endTime,
}: CheckForLecturerConflictArgs): Promise<boolean> => {
  return new Promise<boolean>((resolve) => {
    return checkForTimelineItemTimeConflict({
      filterField: 'lecturerID',
      timelineItems,
      item,
      resolve,
      startTime,
      endTime,
      confirmChange,
    });
  });
};
